import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges, OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AgentRouteScoreModel} from "../../../../agents/angular/models/agent-route-score.model";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import {TaskModel} from "../../../../tasks/models/task.model";

require('./agents-route-score-expandable-table.scss');
@Component({
  standalone: false,
  selector: 'app-agents-route-score-expandable-table',
  templateUrl: './agents-route-score-expandable-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentsRouteScoreExpandableTableComponent implements OnInit, AfterViewInit {

  @Input() agentsRouteScore: AgentRouteScoreModel[];
  @Input() expandedRowsMap: any;
  @Input() onAllowExpand: boolean;
  @Input() isShowTotals: boolean;
  @Input() totals: any;
  @Input() totalsWidgetConfiguration: any;
  @Output() onToggleExpand = new EventEmitter<string>();
  // @Output() fetchNextEvent = new EventEmitter<null>();

  @ViewChild('header', {static: false}) header: ElementRef;
  // @ViewChild(CdkVirtualScrollViewport, {static: false})
  // private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public expandRowsMap: any = {};
  public isBigScreen: boolean;

  constructor(@Inject('agentDialogService') private agentDialogService) {
  }

  ngOnInit() {
    this.isBigScreen = window.innerWidth >= 1200;
  }

  ngAfterViewInit(): void {
  }


}
